export default "__VITE_ASSET__CFEfRPyN__"